import React from 'react';
import type { BootCampPurchaseError as Props } from './boot-camp-purchase-error.types';

const BootCampPurchaseError: React.FC<Props> = ({ debug }) => (
  <div className="boot-camp-purchase-error">
    {debug ? (
      <code>
        <pre>{debug}</pre>
      </code>
    ) : null}
  </div>
);

export default BootCampPurchaseError;
